<script setup lang="ts">
import { ref } from 'vue';
import { getCurrentLocale } from '@/i18n';
import { formatDate } from '@/utils/dateUtils';
import DatePicker from 'primevue/datepicker';

interface Props {
  date: any;
  title: string;
  permission: boolean;
}
const props = defineProps<Props>();

const emits = defineEmits<{ changeDate: [value: any] }>();

const lang = getCurrentLocale();

const editDate = ref({
  isEdit: false,
  data: props.date && new Date(props.date)
});

const handleSave = () => {
  emits('changeDate', editDate.value.data);
  editDate.value.isEdit = false;
};
</script>
<template>
  <div class="date-worksheet-editor font-bold">
    <div class="grid">
      <div class="col-4 mb-4">{{ title }}:</div>
      <div class="col-8 font-normal">
        <div v-if="!editDate.isEdit" class="flex align-items-top">
          <div class="min-w-5rem">
            {{ formatDate(date, 'dd-LLL-yyyy', false, lang) }}
          </div>
          <span class="text-center ml-4">
            <i v-if="permission" class="pi pi-pencil cursor-pointer" @click="editDate.isEdit = true"></i>
          </span>
        </div>
        <div v-else class="flex align-items-top">
          <div class="w-9rem">
            <DatePicker id="calendar-24h" v-model="editDate.data" dateFormat="dd-M-yy">
              <template #footer>
                <p class="text-center">
                  <small>{{ $t('common.press_space') }}</small>
                </p>
              </template>
            </DatePicker>
          </div>
          <div class="text-center ml-4 flex gap-3 align-items-center">
            <i class="pi pi-check cursor-pointer" v-if="editDate.data" @click="handleSave(editDate.data)"></i>
            <i class="pi pi-times cursor-pointer" @click="editDate = { isEdit: false, data: date && new Date(date) }"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
